import './styles/gnb.scss';
import './styles/footer.scss';
import './styles/footer-daum.scss';
import './vendor/add-event-listener-polyfill';
import ready from './vendor/dom-ready';
import lazyLoad from './vendor/lazyload';
import { loadFont } from './gnb/load-font';
import { setGNBState, IGnbOptions } from './gnb/index';
import { IFooterOptions, renderFooter } from './footer/index';

let cssLoaded = false;

function loadStyles(callback: () => void) {
  if (cssLoaded) {
    callback();
    return;
  }

  // CSS_URI가 빌드 시점에 문자열 리터럴로 대체됨
  const cssUri = process.env.CSS_URI;
  if (!cssUri) {
    callback();
    return;
  }

  lazyLoad.css(cssUri, () => {
    cssLoaded = true;
    callback();
  });
}

export function gnb(options: IGnbOptions): void {
  loadStyles(() => {
    setGNBState(options);
  });

  if (options?.font !== false) {
    loadFont();
  }
}

export function footer(options: IFooterOptions): void {
  loadStyles(() => {
    renderFooter(options);
  });
}

export const domReady = (fn: () => void): void => {
  if (typeof fn !== 'function') {
    throw new Error('Missing function!!!');
  }

  ready(fn);
};

export function openPopup(
  url: string,
  name: string,
  width: number,
  height: number
) {
  var options = [
    'left=0',
    'top=0',
    'width=' + width,
    'height=' + height,
    "scrollbars='yes'",
    "resizable='yes'",
    "location='no'",
    "menubar='no'",
    "status='no'",
    "titlebar='no'"
  ];

  var viewportCenter = window.screen.width / 2;
  var viewportMiddle = window.screen.height / 2;

  options.push('left=' + Math.floor(viewportCenter - width / 2));
  options.push('top=' + Math.floor(viewportMiddle - height / 2));

  return window.open(url, name, options.join(','));
}
